import {createStyles, makeStyles} from '@material-ui/core/styles/';

export const useStyles = makeStyles(() => {
  return createStyles({
    wrapperBox: {
      width: '100%'
    },
    heading1: {
      fontSize: '2rem',
      color: '#002677',
      marginTop: '16px',
      lineHeight: 1.3
    },
    link: {
      fontSize: '18px',
      color: '#002677 !important',
      textDecoration: 'underline'
    },
    description: {
      marginTop: '24px',
      color: '#4B4D4F',
      lineHeight: '26px',
      fontSize: '18px'
    },
    description2: {
      marginTop: '8px',
      color: '#4B4D4F',
      lineHeight: '26px',
      fontSize: '18px'
    },
    signBtn: {
      marginTop: '16px',
      minWidth: '180px',
      maxWidth: '220px',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      backgroundColor: '#3D3C38',
      '&:hover': {
        backgroundColor: '#3D3C38'
      }
    },
    bgOverlayImage: {
      height: '100%',
      width: 'auto',
      objectFit: 'contain'
    },
    homeContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0 0 0 40px',
      flexDirection: 'row',
      gap: 16,
      backgroundColor: '#FAFAFA'
    },
    homeContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      maxWidth: '800px',
      paddingTop: '40px'
    },
    categoriesContainer: {
      width: '100%',
      marginTop: '30px'
    },
    '@media (max-width: 1000px)': {
      wrapperBox: {
        justifyContent: 'center'
      },
      homeContainer: {
        display: 'flex',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        gap: 12,
        padding: '24px 24px 0'
      },
      homeContent: {
        maxWidth: '100%',
        gap: 12
      },
      heading1: {
        fontSize: '1.5rem'
      },
      description: {
        fontSize: '16px',
        lineHeight: '24px'
      },
      description2: {
        fontSize: '16px',
        lineHeight: '24px'
      },
      bgOverlayImage: {
        alignSelf: 'center',
        width: '220px',
        maxWidth: '75%'
      }
    }
  });
});
